import { render } from "./alert-box.html?vue&type=template&id=f20e6902&ts=true&external"
import script from "./alert-box.ts?vue&type=script&lang=ts&external"
export * from "./alert-box.ts?vue&type=script&lang=ts&external"

import "./alert-box.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__